<template>
  <div class="patientDashboard">
    <vx-card style="min-height: 540px">
        <div
  v-if="$route.query.searchFlag && ['op','bill','receipt'].includes($route.query.from)"
  style="display:flex; justify-content:flex-end; margin-bottom:8px;"
>
  <feather-icon
    icon="XIcon"
    class="custom-class"
    title="Close"
    style="cursor:pointer"
    @click="closeDashboard"
  />
</div>

      <vue-good-table
        mode="remote"
        :pagination-options="{
          enabled: true,
        }"
        :sort-options="{
          enabled: false,
        }"
        :totalRows="totalRecords"
        :rows="rows"
        :columns="columns"
        :isLoading.sync="isLoading"
        @on-column-filter="onColumnFilter"
        @on-page-change="onPageChange"
        @on-row-dblclick="navigate"
        styleClass="vgt-table condensed"
      />
    </vx-card>
  </div>
</template>

<script>
import flatPickr from "flatpickr";
// import flatPickr from 'vue-flatpickr-component';
import "flatpickr/dist/flatpickr.css";
export default {
  data() {
    return {
      components: {
        flatPickr,
      },
      isLoading: false,
      columns: [
        {
          label: "PATIENT ID",
          field: "patientId",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: " ", // placeholder for filter input
            trigger: "", //only trigger on enter not on keyup
          },
          thClass: "text-left pl-4",
          tdClass: "text-left pl-4",

          width: "100px",
        },
        {
          label: "REGISTER DATE ",
          field: "registerDate",
          type: "date",
          dateInputFormat: "dd-mm-yyyy",
          dateOutputFormat: "dd/mm/yyyy",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "dd/mm/yy", // placeholder for filter input
            trigger: "", //only trigger on enter not on keyup
          },
          width: "130px",
        },
        {
          label: "PATIENT NAME",
          field: "patientName",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: " ", // placeholder for filter input
            trigger: "", //only trigger on enter not on keyup
          },
          width: "190px",
        },
        {
          label: "AGE",
          field: "age",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: " ", // placeholder for filter input
            trigger: "", //only trigger on enter not on keyup
          },
          width: "130px",
          thClass: "text-center ",
          tdClass: "text-center",
        },
        {
          label: "GENDER",
          field: "gender",
          filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: " ", // placeholder for filter input
            trigger: "", //only trigger on enter not on keyup
          },
          width: "120px",
        },

        {
          label: "PHONE NO",
          field: "phoneNo",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: " ", // placeholder for filter input
            trigger: "", //only trigger on enter not on keyup
          },
          width: "150px",
        },
        {
          label: "PLACE",
          field: "place",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: " ", // placeholder for filter input
            trigger: "", //only trigger on enter not on keyup
          },
          width: "150px",
        },
        {
          label: "OP COUNT ",
          field: "opCount",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: " ", // placeholder for filter input
            trigger: "", //only trigger on enter not on keyup
          },
          thClass: "text-center",
          tdClass: "text-center",
          width: "100px",
        },
      ],
      rows: [],
      totalRecords: 0,
      serverParams: {
        companyId: this.$session.get('companyId'),
        filter: {},
        currentPage: 1,
        limit: 10,
      },
    };
  },

  mounted() {
    let inputs = ['input[placeholder="dd/mm/yy"]'];
    inputs.forEach(function (input) {
      flatPickr(input, {
        // dateFormat: "m-d-Y",
        dateFormat: "d-m-Y",
        // mode: "range",
        allowInput: true,
      });
    });
    const savedFilters = this.$store.state.patientDashboardFilters;

    if (savedFilters) {
      this.serverParams = savedFilters;

      const updatedColumns = this.columns.map((col) => {
        if (savedFilters.filter && savedFilters.filter[col.field]) {
          return {
            ...col,
            filterOptions: {
              ...(col.filterOptions || {}),
              filterValue: savedFilters.filter[col.field],
            },
          };
        }
        return col;
      });
      this.columns = updatedColumns;

      this.$store.commit("updatepatientDashboardFilters", null);
    }
    this.loadItems();
  },

  methods: {
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    onPageChange(params) {
      console.log(params);
      this.updateParams({
        currentPage: params.currentPage,
      });
      this.loadItems();
    },
    onColumnFilter(params) {
      this.updateParams({
        filter: params.columnFilters,
      });
      this.loadItems();
    },
    loadItems() {
       this.isLoading = true;
      this.$http
        .post("v2/getpatientlist", JSON.stringify(this.serverParams), {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          console.log("response from patient back end", response.data.data);
          this.totalRecords = response.data.recordsTotal;
          this.rows = response.data.data;
        })
        .catch((error) => {
      console.error("Error loading patient data:", error);
      this.$vs.notify({
        title: "Error",
        text: "Failed to load patient list.",
        color: "danger",
        position: "top-center",
      });
    })
    .finally(() => {
      this.isLoading = false;
    });
        
    },
     closeDashboard() {
    const from = this.$route.query.from

    if (from === 'op') {
      this.$router.push('OpTicket')
    } 
    else if (from === 'bill') {
      this.$router.push('Billing')
    }
     else if (from === 'receipt') {
      this.$router.push('BillDues')
    }
  },

    navigate(item, index, event) {
      this.$store.commit("updatepatientDashboardFilters", this.serverParams);
      console.log(item, index, event);
      console.log(item.row.opNo);
      var selectedPatientId = item.row.patientId;

      if (this.$route.query.searchFlag) {
        this.$store.dispatch("updatePatientId", selectedPatientId);
        this.$router.push({
          path: this.$router.go(-1),
        });
      } else {
        this.$router.push({
          path: "PatientTray",
          query: {
            patientId: selectedPatientId,
          },
        });
      }
    },
  },
};
</script>

<style >
.vgt-table thead th {
  background: white;
}
.vgt-wrap__footer {
  background: white;
}
table.vgt-table {
  font-size: 12px;
  border: none;
}
.vgt-right-align {
  text-align: left;
}
.vgt-table.condensed tr {
  height: 56px;
}
.vgt-table.condensed td {
  padding-top: 19px;
}
.vgt-input {
  border: none;
}
.vgt-wrap__footer {
  border: none;
}

.flatpickr-rContainer {
  width: 95% !important;
}
.dayContainer {
  min-width: 86% !important;
  max-width: 86% !important;
}

.flatpickr-monthDropdown-months {
  margin-left: -18%;
}
.flatpickr-monthDropdown-month {
  font-size: 11 !important;
}
.flatpickr-next-month {
  right: 57px !important;
}
.flatpickr-months {
  width: 97%;
}
.footer__row-count__label,
.footer__row-count__select {
  display: none !important;
}
.patientDashboard .vgt-table thead th:nth-child(4) input {
  
  text-align: center !important;
}

</style>
